import { render } from "./nanamota-commitment.vue?vue&type=template&id=8de8918a&scoped=true"
import script from "./nanamota-commitment.vue?vue&type=script&lang=js"
export * from "./nanamota-commitment.vue?vue&type=script&lang=js"

import "./nanamota-commitment.vue?vue&type=style&index=0&id=8de8918a&scoped=true&lang=css"

import exportComponent from "/Users/suniyl/Documents/work/shopify-projects/behno/behno-us-version-3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8de8918a"]])

export default __exports__